/**
 * Permision models.
 */
export class Permission {
  id?: number;
  abbrv?: string;
  description?: string;
}
